import { Stack, Box, keyframes } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import Text from "src/components/Displays/Text";
import { ThemeValues } from "src/components/ThemeUsage/theme";
import { ThemeContext } from "src/components/ThemeUsage/ThemeUsage";

const pulse = keyframes`
  0% { opacity: 0.45; }
  50% { opacity: 1; }
  100% { opacity: 0.45; }
`;

const PreCalcSkeletonSummary = () => {
  const { t } = useTranslation();
  const themeName = useContext(ThemeContext);
  const isLichtblick = themeName === ThemeValues.lichtblick;

  return (
    <Stack
      sx={(theme) => ({
        paddingTop: { xs: "10px", md: "30px" },
        paddingX: { xs: "10px", md: "24px" },
        paddingBottom: { xs: "10px", md: "24px" },
        bgcolor: isLichtblick ? theme.palette.app.secondary : "#DAECFA",
        width: "100%",
        boxSizing: "border-box",
        borderRadius: "12px",
      })}
    >
      <Stack gap={2} sx={{ width: "100%" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            bgcolor: isLichtblick ? "#BEEDD5" : "#FFFFFF",
            borderRadius: "8px",
            border: isLichtblick ? "none" : "1px solid #039C25",
            width: "100%",
            p: { xs: 2, sm: 2.5 },
            boxSizing: "border-box",
          }}
        >
          <Text
            sx={{
              color: "#222222",
              fontSize: { xs: "11px", sm: "16px" },
              fontWeight: 400,
            }}
            text={t("page.calculatedSavingsSummary.potentialSavings")}
          />
          <Box
            sx={{
              width: { xs: "90px", sm: "130px" },
              height: { xs: "22px", sm: "28px" },
              borderRadius: "14px",
              bgcolor: isLichtblick ? "#48BD57" : "#C6FFB2",
              animation: `${pulse} 1.3s ease-in-out infinite`,
            }}
          />
        </Stack>

        <Stack
          sx={{
            backgroundColor: isLichtblick ? "#BFCEDE" : "#084465",
            borderRadius: "8px",
            width: "100%",
            p: { xs: 1, sm: 1.5 },
            boxSizing: "border-box",
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              backgroundColor: isLichtblick ? "#30475C" : "#105A83",
              px: { xs: 2, sm: 3 },
              py: 2.5,
              borderRadius: 2,
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <Text
              sx={{
                color: isLichtblick ? "#F7BCCE" : "#FFFFFF",
                fontSize: { xs: "11px", sm: "12px" },
                fontWeight: 700,
                lineHeight: "15px",
              }}
              text="StromWallet Dynamic Pro"
            />

            <Stack alignItems="flex-end" gap={0.5}>
              <Box
                sx={{
                  width: { xs: "90px", sm: "120px" },
                  height: { xs: "18px", sm: "22px" },
                  borderRadius: "11px",
                  bgcolor: isLichtblick ? "#F7BCCE" : "#3E7EA3",
                  animation: `${pulse} 1.3s ease-in-out infinite`,
                }}
              />
              <Text
                sx={{ color: "#FFFFFF", fontSize: { xs: "8px", sm: "8px" } }}
                text={t("page.tariff.tariffSelectionContainer.calculatedCosts")}
              />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default PreCalcSkeletonSummary;
